import { render, staticRenderFns } from "./formSentiment.vue?vue&type=template&id=2806fc5b&"
import script from "./formSentiment.vue?vue&type=script&lang=js&"
export * from "./formSentiment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports